// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The Add dialog's form, inside ConfirmDialog's box. Colours, type and
 * geometry come from ../../styles/curioTokens.css.
 */

.afmkKHTYEB2pxa9AQpiQ {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: min(440px, 80vw);
}

.T9oU394E92FLTWOeBr3j {
  margin: 0;
}

.zm2CjCFtYPKxDc6L2PTh,
.mEyp1AGJUg23sck5bYnK {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  border: 0;
}

.UufIg0CIcy6GMZJ2LKcv {
  padding: 0;
  font-size: var(--curio-font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  color: var(--curio-text-muted);
}

.ieyopvzsV5V2SXRoTpwX {
  height: var(--curio-input-height);
  padding: 0 12px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font: inherit;
  font-size: var(--curio-font-size-md);
  min-width: 0;
}

.lQN63AvCclOVVk0GPHWB {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
}

.k1FfkYcPUoIEDFs4ownK {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-primary);
}

.gfxSTcWUdkXu2FWBiP9a {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--curio-font-size-sm);
}

.gfxSTcWUdkXu2FWBiP9a .ieyopvzsV5V2SXRoTpwX {
  flex: 1;
}

.QgJMxInkjr4nY7dK8LC6 {
  margin: 0;
  color: var(--curio-danger-text);
  font-size: var(--curio-font-size-sm);
}

/* Declared parameters: a sentence under a field, and the area field's parts. */
.df9hSqbmXppO0OiZcAQ1 {
  margin: 0;
  color: var(--curio-text-secondary);
  font-size: var(--curio-font-size-sm);
}

.bVll9ax9MnpPsyaIsotI {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.aoFdetZOPn35z8GI3lH7 {
  padding: 4px 10px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font: inherit;
  font-size: var(--curio-font-size-sm);
  cursor: pointer;
}

.fYEwqzMoUPqO7kiwiIz6 {
  background: var(--curio-top-bar-bg);
  border-color: var(--curio-top-bar-bg);
  color: var(--curio-card-bg);
}

.WT_yGY7qa3bpenG6gvUC {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
}

.BxI7rTvFW6f0Sdc4a4Wo {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 6px 10px;
  border: 0;
  background: transparent;
  color: var(--curio-text-primary);
  font: inherit;
  font-size: var(--curio-font-size-sm);
  text-align: left;
  cursor: pointer;
}

.BxI7rTvFW6f0Sdc4a4Wo:hover:not(:disabled),
.txupqRFDNZ95zU7bLUlB {
  background: var(--curio-page-bg);
}

.Biv4FsGlGaKnXli1JOhT {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.fFYopQPmFHFD8_Wr2ELX {
  margin: 0;
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-primary);
  font-variant-numeric: tabular-nums;
}

.AiMiGaHoZ_rJ1rv71TTM {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.MaxPyzjk7pvQwH2ojCgK {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: var(--curio-radius-sm);
  background: var(--curio-page-bg);
  font-size: var(--curio-font-size-sm);
}

.MaxPyzjk7pvQwH2ojCgK button {
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--curio-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/pages/discovery/DiscoveryAddDialog.module.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,aAAa;EACb,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA,+EAA+E;AAC/E;EACE,SAAS;EACT,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,aAAa;EACb,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC","sourcesContent":["/*\n * The Add dialog's form, inside ConfirmDialog's box. Colours, type and\n * geometry come from ../../styles/curioTokens.css.\n */\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: min(440px, 80vw);\n}\n\n.lede {\n  margin: 0;\n}\n\n.field,\n.fieldset {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.fieldLabel {\n  padding: 0;\n  font-size: var(--curio-font-size-xs);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 600;\n  color: var(--curio-text-muted);\n}\n\n.input {\n  height: var(--curio-input-height);\n  padding: 0 12px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font: inherit;\n  font-size: var(--curio-font-size-md);\n  min-width: 0;\n}\n\n.values {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n}\n\n.value {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-primary);\n}\n\n.range {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--curio-font-size-sm);\n}\n\n.range .input {\n  flex: 1;\n}\n\n.warning {\n  margin: 0;\n  color: var(--curio-danger-text);\n  font-size: var(--curio-font-size-sm);\n}\n\n/* Declared parameters: a sentence under a field, and the area field's parts. */\n.hint {\n  margin: 0;\n  color: var(--curio-text-secondary);\n  font-size: var(--curio-font-size-sm);\n}\n\n.modes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.modeBtn {\n  padding: 4px 10px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font: inherit;\n  font-size: var(--curio-font-size-sm);\n  cursor: pointer;\n}\n\n.modeBtnActive {\n  background: var(--curio-top-bar-bg);\n  border-color: var(--curio-top-bar-bg);\n  color: var(--curio-card-bg);\n}\n\n.places {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 180px;\n  overflow-y: auto;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n}\n\n.place {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 6px 10px;\n  border: 0;\n  background: transparent;\n  color: var(--curio-text-primary);\n  font: inherit;\n  font-size: var(--curio-font-size-sm);\n  text-align: left;\n  cursor: pointer;\n}\n\n.place:hover:not(:disabled),\n.placeActive {\n  background: var(--curio-page-bg);\n}\n\n.coordinates {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.boxSummary {\n  margin: 0;\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-primary);\n  font-variant-numeric: tabular-nums;\n}\n\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-page-bg);\n  font-size: var(--curio-font-size-sm);\n}\n\n.chip button {\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  color: var(--curio-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `afmkKHTYEB2pxa9AQpiQ`,
	"lede": `T9oU394E92FLTWOeBr3j`,
	"field": `zm2CjCFtYPKxDc6L2PTh`,
	"fieldset": `mEyp1AGJUg23sck5bYnK`,
	"fieldLabel": `UufIg0CIcy6GMZJ2LKcv`,
	"input": `ieyopvzsV5V2SXRoTpwX`,
	"values": `lQN63AvCclOVVk0GPHWB`,
	"value": `k1FfkYcPUoIEDFs4ownK`,
	"range": `gfxSTcWUdkXu2FWBiP9a`,
	"warning": `QgJMxInkjr4nY7dK8LC6`,
	"hint": `df9hSqbmXppO0OiZcAQ1`,
	"modes": `bVll9ax9MnpPsyaIsotI`,
	"modeBtn": `aoFdetZOPn35z8GI3lH7`,
	"modeBtnActive": `fYEwqzMoUPqO7kiwiIz6`,
	"places": `WT_yGY7qa3bpenG6gvUC`,
	"place": `BxI7rTvFW6f0Sdc4a4Wo`,
	"placeActive": `txupqRFDNZ95zU7bLUlB`,
	"coordinates": `Biv4FsGlGaKnXli1JOhT`,
	"boxSummary": `fFYopQPmFHFD8_Wr2ELX`,
	"chips": `AiMiGaHoZ_rJ1rv71TTM`,
	"chip": `MaxPyzjk7pvQwH2ojCgK`
};
export default ___CSS_LOADER_EXPORT___;
